import axiosInstance from "../../config/Axios";
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

const login = async (email,password) => {
    try {
        return await axiosInstance({
            method: 'post',
            url: '/api/auth/signin/',
            data: {
                email: email,
                password: password,
                client_type: "web"
            }
        });
    } catch (error) {
        return Promise.reject(error.response.data);
    }
}

const register = async (name, email, password, confirmPassword, agreement) => {
    return await axiosInstance({
        method: 'post',
        url: '/api/auth/signup/',
        data: {
            name: name,
            email: email,
            password: password,
            confirm_password: confirmPassword,
            agreement: agreement
        }
    });
}

const forgotPassword = async (email) => {
    return await axiosInstance({
        method: 'post',
        url: '/api/auth/forgot-password/',
        data: {
            email: email
        }
    });
}

const resetPassword = async (uid, token, password, confirmPassword) => {
    return await axiosInstance({
        method: 'post',
        url: `/api/auth/reset-password/${uid}/${token}/`,
        data: {
            uid: uid,
            token: token,
            password: password,
            confirm_password: confirmPassword
        }
    });
}

const getAuthTokenFromRefreshToken = async (refreshToken) => {
    return await axios({
        method: 'post',
        url: `${baseURL}/api/token/refresh/`,
        headers: {
        'Content-Type': 'application/json'
        },
        data: {
            refresh: refreshToken
        }
    });
}

const getCurrentUserData = async () => {
    return await axiosInstance({
        method: 'get',
        url: '/api/auth/me/',
    });
}

const logout = async (refreshToken) => {
    try {
        return await axiosInstance({
            method: 'post',
            url: '/api/auth/signout/',
            data: {
                refresh: refreshToken
            }
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

const getUsers = async ({ page = 1, limit = 10, search = '', isActive = null } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: '/api/auth/users/',
            params: {
                limit,
                offset,
                search,
                is_active: isActive
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

const getUser = async (id) => {
    return await axiosInstance({
        method: 'get',
        url: `/api/auth/users/${id}/`,
    });
}

const createUser = async (userData) => {
    return await axiosInstance({
        method: 'post',
        url: '/api/auth/users/',
        data: userData
    });
}

const updateUser = async (id, userData) => {
    try {
        const response = await axiosInstance({
            method: 'put',
            url: `/api/auth/users/${id}/`,
            data: {
                email: userData.email,
                name: userData.name,
                role: userData.role,
                is_active: userData.is_active,
                ...(userData.password && { password: userData.password })
            }
        });
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
}

const deleteUser = async (id) => {
    return await axiosInstance({
        method: 'delete',
        url: `/api/auth/users/${id}/`,
    });
}

const toggleUserActive = async (userId) => {
    try {
        const response = await axiosInstance({
            method: 'post',
            url: `/api/auth/users/${userId}/toggle_active/`,
        });
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

const getRoles = async () => {
    return await axiosInstance({
        method: 'get',
        url: '/api/auth/roles/',
    });
}

const updateUserRole = async (id, roleId) => {
    return await axiosInstance({
        method: 'patch',
        url: `/api/auth/users/${id}/`,
        data: { role: roleId }
    });
}

const updateCurrentUser = async (userData) => {
    return await axiosInstance({
        method: 'put',
        url: '/api/auth/me/',
        data: userData
    });
}

export {
    login,
    register,
    forgotPassword,
    resetPassword,
    getAuthTokenFromRefreshToken,
    getCurrentUserData,
    logout,
    getUsers,
    getUser,
    createUser,
    updateUser,
    deleteUser,
    getRoles,
    updateUserRole,
    updateCurrentUser,
    toggleUserActive,
};